<template>
    <ContentOrLoading>
        <div id="paso2_RA" class="container" v-if="zona">
            <div class="row mb-3">
                <div class="col-12 col-md-8">
                    <h2 class="m-0 h1 text-uppercase align-self-end">{{ $t(!event.reserva_instalaciones ? 'partido.elige_asientos' : 'partido.elige_reservas') }}</h2>
                    <div class="d-flex justify-content-between">
                        <h3 class="subtitle h3 light align-self-end">{{ $t('partido.varios_asientos') }}</h3>
                        <button v-if="puede_cambiar" @click="reset" class="h6 button small-button mr-0" :disabled="paso3"><i class="fa fa-redo"></i> {{ $t('partido.cambiar_zona') }}</button>
                    </div>
                </div>          
            </div>
            <div class="row" v-if="zona.tipo_svg === 1">
                <div class="col-12 col-lg-4">
                    <div class="row">
                        <span class="col-12">
                            <div v-for="(plaza, index) in plazasSeleccionadas" class="lightgray-content p-2 mb-2" :key="index">
                                <div class="text-bold mb-2 d-flex justify-content-between">
                                    <div class="oswald d-flex">
                                        {{ (num = index + 1) }}. {{ getButacaName(plaza) }}
                                    </div>
                                    <span role="button" class="oswald" @click="clickZona(plaza)">
                                        <i class="fas fa-times mr-2"></i>
                                    </span>
                                </div>
                                <div class="form-group mb-1">
                                    <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                                        <select name="precio" v-model="plaza.precioSeleccionado"
                                                :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                        >
                                            <option :value="null" disabled hidden>{{ $t("partido.tipo_entrada") }} 
                                            </option>
                                            <option v-for="(precio, index) in plaza.precios" :key="index" :value="precio">
                                                {{ precio.descripcion }} / {{ precio.precio | formatear_precio }}
                                            </option>
                                        </select>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <b-button 
                                v-if="plazasSeleccionadas.length > 0" 
                                class="float-right"
                                :disabled="continuarConCompra || !precioSeleccionadoValido"
                                @click="continuarCompra"
                            >
                                {{ $t('partido.continuar') }}
                            </b-button>
                        </span>
                    </div>
                </div>
                <div class="col-12 col-lg-8 order-first order-lg-last mb-3 mb-lg-0">
                    <div class="lightgray-content">
                        <ContentOrLoading style="min-height: 300px;">
                            <RecintoAnexoComponent 
                                class="col-12"
                                :region_id="zona.id"
                                :plazas="plazas"
                                :plazasSeleccionadas="plazasSeleccionadas"
                                :continuarConCompra="continuarConCompra"
                                :tipo_svg="parseInt(zona.tipo_svg, 10)"
                                :sectores="sectores"
                                :disabled="continuarConCompra || !precioSeleccionadoValido"
                                @clickZona="clickZona"
                                v-if="plazas.length > 0"
                            />
                        </ContentOrLoading>
                    </div>
                </div>
            </div>
            <div v-else class="row">
                <div class="col-12 col-lg-8">
                    <div v-if="!load_panzoom && svgGeneral" class="pb-3">
                        <div id="minimap" class="col-12 lightgray-content">
                            <SvgComponent
                                :place="event.place"
                                :sesion_id="sesion_id"
                                :zonas="zonas"
                                :zona_id="zona.id"
                                :svgGeneral="svgGeneral"
                                @cargado="selectSector"
                                @clickZona="cambiarSector"
                            />
                        </div>
                    </div>
                    <div class="lightgray-content" id="seat-map">
                        <ContentOrLoading style="min-height: 300px;">
                            <RecintoAnexoComponent 
                                class="col-12"
                                :region_id="zona.id"
                                :plazas="plazas"
                                :plazasSeleccionadas="plazasSeleccionadas"
                                :continuarConCompra="continuarConCompra"
                                :tipo_svg="parseInt(zona.tipo_svg, 10)"
                                :sectores="sectores"
                                :precios="precios"
                                :disabled="continuarConCompra || !precioSeleccionadoValido"
                                @clickZona="clickZona"
                                v-if="plazas.length > 0"
                            />
                        </ContentOrLoading>
                    </div>
                </div>
                <div class="col-12 col-lg-4 d-flex flex-column">
                    <div v-if="load_panzoom && svgGeneral" class="pb-3">
                        <div id="minimap" class="col-12 lightgray-content">
                            <SvgComponent
                                :place="event.place"
                                :sesion_id="sesion_id"
                                :zonas="zonas"
                                :zona_id="zona.id"
                                :svgGeneral="svgGeneral"
                                @cargado="selectSector"
                                @clickZona="cambiarSector"
                            />
                        </div>
                    </div>
                    <div class="d-flex flex-column justify-content-between" :style="dynamicStyle()">
                        <div class="overflow-auto" :class="[svgGeneral ? 'tusEntradasSvgGeneral' : 'tusEntradas']">
                            <div v-for="(plaza, index) in plazasSeleccionadas" class="lightgray-content p-2 mb-2" :key="index">
                                <div class="text-bold mb-2 d-flex justify-content-between">
                                    <div class="oswald">
                                        {{ (num = index + 1) }}.  <span v-html="getButacaName(plaza)"></span>                        
                                    </div>
                                    <span role="button" class="oswald" @click="clickZona(plaza)">
                                        <i class="fas fa-times mr-2"></i>
                                    </span>
                                </div>
                                <div class="form-group mb-1">
                                    <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                                        <select 
                                            name="precio" 
                                            v-model="plaza.precioSeleccionado"
                                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                            :disabled="continuarConCompra || !preciosEnPlazas"
                                            @change="actualizarEstadoPrecios"
                                        >
                                            <option :value="null" disabled hidden>
                                                {{ $t("partido.tipo_entrada") }} 
                                            </option>
                                            <option v-for="(precio, index) in plaza.precios" :key="index" :value="precio">
                                                {{ precio.descripcion }} / {{ precio.precio | formatear_precio }}
                                            </option>
                                        </select>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                        <VisibilidadReducida tipo="butaca" :zona="zona" @aceptar="AceptarVisibilidadReducida"/>
                        <b-row v-if="teatro.carrito_varios_eventos">
                            <template v-if="!carrito || carrito.items_count == 0">
                                <b-col cols="9">
                                    <b-button 
                                        v-if="plazasSeleccionadas.length > 0 && confValida" 
                                        class="btn btn-block"
                                        :disabled="continuarConCompra || !precioSeleccionadoValido || bloquear"
                                        @click="continuarCompra"
                                    >
                                        {{ $t('partido.continuar') }}
                                    </b-button>
                                </b-col>
                                <b-col cols="3">
                                    <b-button
                                        data-cy="add-cart-recinto-anexo"
                                        v-if="plazasSeleccionadas.length > 0 && confValida"
                                        class="btn btn-block"
                                        :disabled="continuarConCompra || !precioSeleccionadoValido  || bloquear"
                                        @click="checkCarrito()"
                                    >
                                        <i class="fa fa-cart-plus" aria-hidden="true"></i>
                                    </b-button>
                                </b-col>
                            </template>
                            <template v-else>
                                <b-col cols="12">
                                    <b-button 
                                        v-if="plazasSeleccionadas.length > 0 && confValida" 
                                        class="btn btn-block"
                                        :disabled="continuarConCompra || !precioSeleccionadoValido  || bloquear"
                                        @click="checkCarrito()"
                                    >
                                        {{ $t('carrito.añadir') }}
                                    </b-button>
                                </b-col>
                            </template>                            
                        </b-row>
                        <b-row v-else>
                            <b-col>
                                <b-button 
                                    v-if="plazasSeleccionadas.length > 0 && confValida" 
                                    class="btn btn-block mb-0"
                                    :disabled="continuarConCompra || !precioSeleccionadoValido || bloquear"
                                    @click="continuarCompra"
                                >
                                    {{ $t('partido.continuar') }}
                                </b-button>
                            </b-col>   
                        </b-row>
                        <div 
                            v-if="plazasSeleccionadas.length > 0 && !confValida"
                            class="text-white bg-danger p-2 font-weight-bold rounded w-100 text-center"
                        >
                            ¡No puedes dejar huecos entre butacas!
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import RecintoAnexoComponent from '@/components/svg/RecintoAnexoComponent';
    import SvgComponent from '@/components/svg/SvgComponent';
    import VisibilidadReducida from '@/components/frontend/components/modals/VisibilidadReducida.vue';
    import comprobarButacasLeaflet from '@/mixins/comprobarButacasLeaflet.js';

    export default {
        props: ['zona', 'event', 'paso3', 'session_id', 'continuarConCompra', 'buttonCambiar', 'svgGeneral', 'zonas', 'sesion_id'],
        mixins: [comprobarButacasLeaflet],
        data() {
            return {
                svg_code: null,
                plazasSeleccionadas: [],
                sectores: null,
                precios: [],
                plazasConf: null,
                plazas: [],
                bloquear: false, 
                precioSeleccionadoValido: false
            }
        },
        created() {
            this.getRecintoAnexo();
        },
        watch: {
            plazasSeleccionadas() {
                for (let i in this.plazasSeleccionadas) {
                    if (!this.plazasSeleccionadas[i].precioSeleccionado) {
                        this.plazasSeleccionadas[i].precioSeleccionado =
                            this.plazasSeleccionadas[i].precios.length === 1 ? this.plazasSeleccionadas[i].precios[0] : null;
                        this.actualizarEstadoPrecios()
                    }
                }
            },
            plazasConVisibilidadReducida(newVal) {
                if (newVal) {
                    this.$modal.show('visibilidad-reducida');
                }
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            plazasConVisibilidadReducida() {
                return this.plazasSeleccionadas.some(plaza => plaza.visibilidad_reducida);
            },
            load_panzoom() {
                let load_panzoom = true

                let userAgent = navigator.userAgent || navigator.vendor || window.opera;

                if(/windows phone/i.test(userAgent) || /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    load_panzoom = false;
                }

                return load_panzoom;
            },
            puede_cambiar() {
                return this.zonas.filter(zona => zona.precios.length > 0).length > 0 || this.plazas.filter(plaza => plaza.precios.length > 0).length > 0;
            },
            preciosEnPlazas() {
                return this.plazasSeleccionadas.every(plaza => plaza.precios);
            },
            precioSeleccionado() {
                return this.plazasSeleccionadas.some(plaza => plaza.precioSeleccionado);
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            carrito() {
                return this.$store.getters.getCarritoActivoOnline;
            },
        },
        methods: {
            AceptarVisibilidadReducida(){
                this.$modal.hide('visibilidad-reducida');
            }, 
            actualizarEstadoPrecios() {
                this.precioSeleccionadoValido = this.plazasSeleccionadas.some(plaza => plaza.precioSeleccionado !== null);
            },
            getRecintoAnexo() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    evento_id: this.event.id,
                    sesion_id: this.sesion_id,
                    zona_id: this.zona.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.events.sesion.zona.anexa.butacas'), params)
                    .then(({ data: { data } }) => {
                        this.plazas = data;
                        setTimeout(() => {
                            this.$scrollTo('#paso2_RA', 500)
                        }, 400);
                        this.setPlazasConf(this.plazas);
                    })
            },
            clickZona(plazaSeleccionada) {
                if (!this.continuarConCompra) {
                    this.plazas.find(plaza => {
                        if (plaza.id == plazaSeleccionada.id) {
                            plaza.seleccionada = plaza?.seleccionada && plaza.seleccionada ? false : true;
                            if (plaza.seleccionada) {
                                if (this.zona.tipo_svg === 1) {
                                    document.getElementById('popover-' + plaza.id).classList.add('seleccionada');
                                }
                                this.plazasSeleccionadas.push(plazaSeleccionada);
                                this.plazasSeleccionadas.sort((a, b) => a.butaca - b.butaca);
                            } else {
                                if (this.zona.tipo_svg === 1) {
                                    document.getElementById('popover-' + plaza.id).classList.remove('seleccionada');
                                }
                                if (this.zona.tipo_svg === "2") {
                                    const butacaElement = document.getElementById('butaca-' + plaza.svg_id);
                                    if (butacaElement) {
                                        butacaElement.setAttribute('seleccionado', 'false');
                                        butacaElement.setAttribute('fill', '#0CBA31');
                                    }
                                }

                                const index = this.plazasSeleccionadas.findIndex(plaza => plaza.id == plazaSeleccionada.id);
    
                                if (index !== -1) {
                                    this.plazasSeleccionadas.splice(index, 1);
                                }
                            }
                        }
                    });                
                }
            },
            reset() {
                this.$emit('reset', true);
            },
            continuarCompra() {
                this.bloquear = true;

                let data = this.plazasSeleccionadas.map(plaza => {
                    return {
                        "butaca_id": plaza.id,
                        "precio_id": plaza.precioSeleccionado.id
                    }
                });

                let params = {
                    filters: {},
                    event_id: this.$route.params.event_id,
                    sesion_id: this.$route.params.sesion_id,
                    session_id: this.session_id,
                    data: data
                }
            
                this.$store.dispatch(this.config.getVuexAlias('front.evento.sesion.bloquear-butacas'), params).then(({ data }) => {
                    sessionStorage.setItem('session_id', data.session_id);
                    this.$emit('setPlazas', this.plazasSeleccionadas);
                    this.$emit('goTo', data.session_id);
                    this.$emit('setCartId', data.cart_id);
                }).catch(error => {
                    this.$toast.error('Butaca/s ocupada/s');
                    this.$emit('cambiar-asiento', true);
                }).finally(() => {
                    this.bloquear = false;
                });
            },
            checkCarrito() {
                if (this.carrito) {
                    this.setItemsCarrito();
                } else {
                    this.crearCarrito();
                }
            },
            async crearCarrito() {
                const params = { filters: {}, uuid: localStorage.getItem('uuid') };

                return this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.crear'), params).then(res => {
                    this.setItemsCarrito();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            setItemsCarrito() {            

                this.bloquear = true;
            
                const params = {
                    filters: {uuid: localStorage.getItem('uuid')},
                    cart_id: this.carrito?.id,
                    plazas: this.getPlazasFormatted(),
                    asientos: []
                };

                this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.add-items'), params).then(res => {
                    this.$toast.success('Entradas añadidas al carrito correctamente.');
                    this.$store.dispatch('USUARIO_CARRITO_ACTIVO', {filters:{ uuid: localStorage.getItem('uuid')}});
                    this.$router.push({path: "/eventos"});
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.bloquear = false;
                });
            },
            getPlazasFormatted() {
                let plazas = [];

                this.plazasSeleccionadas.map(plaza => {
                    plazas.push({
                        precio: {
                            id: plaza.precioSeleccionado.id
                        },
                        id: plaza.id,
                        event_id:this.$route.params.event_id,
                        event_session_id: this.$route.params.sesion_id,
                        region_id: this.zona.id
                    })
                });

                return plazas;
            },
            getButacaName(plaza) {
                const nButaca = plaza.butaca;
                const nFila = plaza.fila;
                const visibilidad_reducida = plaza.visibilidad_reducida;
                const porcentaje_visibilidad = plaza.porcentaje_visibilidad;
                let name = '';

                if(this.sectores) {
                    const sector = this.sectores.find(sector => sector.id == plaza.sector);
                    if (sector) {
                        name += `Sector: ${sector.name} - `;
                    }
                }       

                if (!this.event.reserva_instalaciones) {
                    if (!nButaca && !nFila) {
                        name += `Plaza: ${plaza.numero}`;
                    } else {
                        name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                    }
                } else {
                    name += 'Reserva';
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            getButacasLibresPrecio(precioId) {
                return this.plazas.filter(plaza => {
                    return plaza.disponible && plaza.precios.some(precio => precio.id == precioId);
                }).length;
            },
            selectSector() {
                setTimeout(() => {
                    const sectorSelected = document.querySelector(`#minimap [id="popover-${this.zona.id}"] path`);
                    if (sectorSelected) {
                        sectorSelected.setAttribute('fill', '#457ad1')
                    }
                }, 100);
            },
            cambiarSector(sector) {
                this.$emit('cambiarSector', sector);
            },
            dynamicStyle() {
                const botonesVisibles = (this.plazasSeleccionadas.length > 0 && this.confValida && this.teatro.carrito_varios_eventos)
                    + (this.plazasSeleccionadas.length > 0 && this.confValida && !this.carrito);
                return {
                    height: botonesVisibles  === 1 ? '100%': '94.2%'
                }
            }
        },
        components: { RecintoAnexoComponent, SvgComponent, VisibilidadReducida }
    }
</script>

<style scoped>
.border-left {
    border-width: 3px !important;
}

@media only screen and (min-width: 768px) {
    .tusEntradasSvgGeneral {
        height: 250px;
    }

    .tusEntradas {
        height: 480px;
    }

    .dropdown:hover .dropdown-menu {
        display: block;
        margin-top: 0;
    }
}
</style>